export default __webpack_public_path__ + "static/media/icon-a.50acffab.svg";